import { render, staticRenderFns } from "./TextAnnouncementsTabs.vue?vue&type=template&id=6461934b"
import script from "./TextAnnouncementsTabs.vue?vue&type=script&lang=js"
export * from "./TextAnnouncementsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports